const educationSteps = [
  {
    id: 1,
    title: 'Регистрируетесь',
    description:
      'Обучение проходит на платформе Medpoint - наша собственная разработка, которую мы постоянно улучшаем. Доступ к материалам открывается сразу же после оплаты курса.',
  },

  {
    id: 2,
    title: 'Проходите курс в удобном для себя темпе',
    description:
      'Курсы состоят из тематических видео разной длительности, реальных клинических случаев из практики лекторов и актуальных статей из международных источников. Вы можете приступить к прохождению программы в любой момент и прослушать курс в удобном темпе. Доступ бессрочный, чтобы вы всегда могли вернуться и повторить материал.',
  },

  {
    id: 3,
    title: 'Закрепляете изученный материал',
    description: 'В конце курса вы сможете повторить материал, пройдя итоговое тестирование.',
  },

  {
    id: 4,
    title: 'Получаете удостоверение установленного образца',
    description:
      'После прохождения курса и тестирования в течение 10 дней вам на почту поступит удостоверение, которое вы сможете загрузить на сайт Росминздрава.',
  },
]

export { educationSteps }
